export { default as General } from 'accounts/components/form/sections/AccountFormGeneral';
export { default as Depreciations } from 'accounts/components/form/sections/AccountFormDepreciations';
export { default as CustomFields } from 'accounts/components/form/sections/AccountFormCustomFields';



// WEBPACK FOOTER //
// src/modules/secured/modules/accounts/components/form/sections/index.js